import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

// Pastille de statut Loki (En stock / Précommande / Épuisé) : le bloc custom-liquid n'est
// pas re-rendu par Horizon au changement de variante — on suit le même pattern que
// product-inventory.js : écouter productSelect et se morpher depuis le HTML re-rendu.
class ProductStatusLoki extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const newStatus = detail.html.querySelector('product-status-loki');
        if (!newStatus) return;

        morph(this, newStatus, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-status-loki] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('product-status-loki')) {
  customElements.define('product-status-loki', ProductStatusLoki);
}
